<template>
    <div class="helpCenter">
        <div class="title font18">帮助中心</div>
        <van-tabs v-model="tab" color='#3b88fa' v-if="!$route.query.typeCode">
          <van-tab :title="item.typeName" :name='item.typeCode' v-for='(item,i) in typeList' :key='i'></van-tab>
        </van-tabs>
        <div class='list' v-if="list.length>0">
            <div class="line" v-for="(item,i) in list" :key='i' @click="gotoUrl('helpDetail',{id:item.id})">{{item.title}}<span class="gray font16"><svg-icon icon-class="right"/></span></div>
        </div>
        <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>
        
       
        <!-- <div class='loading' v-if="loading"><van-loading type="spinner" color="#fff" /></div> -->
    </div>
</template>
<script>
   import {getHelpType,getHelpList} from '@/api/api.mine.js';
    export default {
        data() {
            return {
                typeList:[],
                list:[],
                tab:this.$route.query.typeCode||'',
                loading:true,
                text:'',
            }
        },
        created(){
          if(this.tab){
            this.getList();
          }else{
            this.getType();
          }
          
        },
        methods:{
            getType(){
              getHelpType().then(data=>{
                if(data.result){
                  this.typeList=data.result;
                  this.tab=data.result[0].typeCode;
                }
              })
            },
            getList(){
              this.list=[];
              this.text='';
              this.loading=true;
              getHelpList({
                typeCode:this.tab
              }).then(data=>{
                this.loading=false
                if(data.result&&data.result.length>0){
                  this.list=data.result;
                }else{
                  this.text='暂无数据';
                }
              }).catch(()=>{
                this.loading=false;
              })
            },
        },
        watch:{
          tab(news){
            if(news){
              this.getList();
            }
          }
        }
    }
</script>
<style lang="scss" >
    .helpCenter{
        font-size: .17rem;
        color:rgba(0,0,0,.9);
        padding-bottom: .12rem;
        .title{
          background:#fff;
          line-height: .44rem;
          text-align: center;
          border-bottom: 1px solid #eee;
        }
        .van-tabs{
          line-height: initial;
          .van-tab--active{
            color: #3b88fa;
          }
          .van-tab{
            font-size: .15rem;
            line-height: .3rem;
            color:#000;
          }
        }
        .list{
          margin:.12rem;
          background:#fff;
          border-radius: 8px;
          padding:.12rem;
          .line{
             padding:.12rem 0;
             border-bottom: 1px solid #DCDCDC;
             position: relative;
             overflow: hidden;
             white-space: nowrap;
             text-overflow: ellipsis;
             padding-right: .5rem;
             &:hover{
               color:#3b88fa;
               cursor: pointer;
             }
             &:last-child{
              border-bottom: none;
             }
             .gray{
               position: absolute;
               right: 0px;
             }
            }
        }
            
       
    }
    @media screen and(min-width:1024px){
      .helpCenter{
         width:500px;
         margin: 0px auto;
      }
}
</style>
